// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class ApiMintMetrics {
    'card': number;
    'mint_time': number;
    'subscriptions': number;
    'mints': number;
    'edition_size': number | null;
    'unminted': number;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "card",
            "baseName": "card",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "mint_time",
            "baseName": "mint_time",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "subscriptions",
            "baseName": "subscriptions",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "mints",
            "baseName": "mints",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "edition_size",
            "baseName": "edition_size",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "unminted",
            "baseName": "unminted",
            "type": "number",
            "format": "int64"
        }    ];

    static getAttributeTypeMap() {
        return ApiMintMetrics.attributeTypeMap;
    }

    public constructor() {
    }
}

